export default "__VITE_ASSET__tbBaYXdy__"